export default "__VITE_ASSET__CQVCcdkd__"